import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_READ_CASES } from 'constants/urls';
import { ActivityLogFilters } from './types';

/**
 * Fetches a paginated list of activity logs (cases with GroupTitle: 'Dispatch').
 * This calls the same ReadCases endpoint but with the Dispatch group filter pre-applied.
 * @param filters - Optional search/filter/pagination params
 * @returns The API response data (paginated activity log list)
 * @throws Re-throws any Axios error after logging
 */
const getActivityLogs = async (filters: ActivityLogFilters = {}) => {
  const payload = {
    SearchKeyword: filters.SearchKeyword || '',
    Page: filters.Page || 1,
    Take: filters.Take || 1000,
    ...filters,
    GroupTitle: 'Dispatch',
  };

  try {
    const { data } = await axiosInstance.get(
      `${URL_CANTRACK_READ_CASES}?payload=${JSON.stringify(payload)}`,
    );
    return data;
  } catch (error) {
    console.error('[getActivityLogs] Failed:', error);
    throw error;
  }
};

export default getActivityLogs;
